import { render, staticRenderFns } from "./BindsDatepickerDialog.vue?vue&type=template&id=622a2250&"
import script from "./BindsDatepickerDialog.vue?vue&type=script&lang=js&"
export * from "./BindsDatepickerDialog.vue?vue&type=script&lang=js&"
import style0 from "./BindsDatepickerDialog.vue?vue&type=style&index=0&id=622a2250&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports